// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CqrqOsr0e73kQjOUFQnz{white-space:pre-wrap}", "",{"version":3,"sources":["webpack://./src/features/server/views/ServerDashboardView/view.module.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA","sourcesContent":[".serverStatus{\n  white-space: pre-wrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"serverStatus": "CqrqOsr0e73kQjOUFQnz"
};
export default ___CSS_LOADER_EXPORT___;
